module.exports = __webpack_public_path__ + "img/IT0000104747993.026b4de4.png";